import content from "@docs/user-guide.md?raw";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function HelpPage() {
	return (
		<div className="mx-auto max-w-4xl p-6">
			<div className="rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
				<article className="prose prose-slate max-w-none prose-headings:scroll-mt-20 prose-table:text-sm">
					<Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
				</article>
			</div>
		</div>
	);
}
